// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import ReactGA from 'react-ga4'

/**
 * Triggers a pageview hitType in GA4.
 * @param {string} page - url to the page
 * @param {string} title - page title
 */
const pageView = (page, title) => {
  ReactGA.send({
    hitType: 'pageview',
    page,
    title,
  })
}

export default pageView
